import React from 'react';
import '../styles/pages/Career.css';
import '../styles/GlobalSections.css';

const jobRoles = [
  {
    title: 'Software Engineer / IT Professional',
    salary: '₹6 – ₹25+ LPA',
    description: 'Build and maintain KYC verification platforms',
    responsibilities: [
      'Develop KYC verification platforms and APIs',
      'Build mobile apps and web portals',
      'Manage data security and cloud infrastructure',
      'Maintain real-time KYC processing systems'
    ],
    skills: ['Java, Python, Node.js', 'Database and cloud technologies', 'Cybersecurity knowledge']
  },
  {
    title: 'Risk & Compliance Officer',
    salary: '₹5 – ₹20 LPA',
    description: 'Ensure regulatory compliance and manage risk',
    responsibilities: [
      'Ensure RBI and regulatory compliance',
      'Manage data privacy and security policies',
      'Handle audit and regulatory reporting'
    ],
    skills: ['Law, CA, CS, MBA Finance', 'Knowledge of RBI and financial regulations']
  },
  {
    title: 'Business Development & Sales',
    salary: '₹3 – ₹18 LPA',
    description: 'Build partnerships and drive business growth',
    responsibilities: [
      'Build partnerships with banks and NBFCs',
      'Sell KYC solutions and analytics products',
      'Manage corporate relationships'
    ],
    skills: ['MBA Marketing / Finance', 'Strong communication and negotiation skills']
  },
  {
    title: 'Customer Support & Operations',
    salary: '₹3.5 – ₹9 LPA',
    description: 'Provide excellent customer service and support',
    responsibilities: [
      'Handle customer KYC report queries',
      'Manage dispute resolution',
      'Support verification and onboarding processes'
    ],
    skills: ['Any graduate', 'Good communication skills']
  }
];

export default function Career() {
  return (
    <div className="career-page">
      <section className="career-hero">
        <div className="hero-overlay"></div>
        <div className="container">
          <h1 className="hero-title">Careers at LCS</h1>
          <p className="hero-subtitle">Join India's fastest-growing KYC information company</p>
          <p className="hero-description">
            Shape the future of financial services and make a real impact in India's lending ecosystem
          </p>
        </div>
      </section>

      <section className="career-intro section-white">
        <div className="container">
          <div className="intro-content">
            <h2>Why Join LCS?</h2>
            <p className="intro-text">
              A career in a KYC Verfication Company offers exciting opportunities in the fast-growing financial and fintech sector. 
              KYC Verification companies play a vital role in the banking ecosystem by providing KYC reports, risk analysis, and 
              financial intelligence to banks, NBFCs, fintech firms, and other financial institutions.
            </p>
            <p className="intro-text">
              With the rapid growth of digital lending, data analytics, and financial inclusion, KYC Verification companies have become 
              one of the most promising career destinations in India.
            </p>
          </div>

          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">💼</div>
              <h3>Competitive Salary</h3>
              <p>Industry-leading compensation packages</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">🚀</div>
              <h3>Career Growth</h3>
              <p>Fast-track advancement opportunities</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">🎓</div>
              <h3>Learning & Development</h3>
              <p>Continuous training and skill enhancement</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">⚖️</div>
              <h3>Work-Life Balance</h3>
              <p>Flexible working arrangements</p>
            </div>
          </div>
        </div>
      </section>

      <section className="job-roles section-light-blue">
        <div className="container">
          <h2>Open Positions</h2>
          <div className="roles-grid">
            {jobRoles.map((role, index) => (
              <div key={index} className="role-card">
                <div className="role-header">
                  <h3>{role.title}</h3>
                  <span className="role-salary">{role.salary}</span>
                </div>
                <p className="role-description">{role.description}</p>
                
                <div className="role-section">
                  <h4>Responsibilities:</h4>
                  <ul>
                    {role.responsibilities.map((resp, idx) => (
                      <li key={idx}>{resp}</li>
                    ))}
                  </ul>
                </div>

                <div className="role-section">
                  <h4>Required Skills:</h4>
                  <ul>
                    {role.skills.map((skill, idx) => (
                      <li key={idx}>{skill}</li>
                    ))}
                  </ul>
                </div>

                <button className="btn-apply">Apply Now</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="career-growth section-white">
        <div className="container">
          <h2>Career Growth Path</h2>
          <p className="growth-subtitle">Progressive career advancement opportunities at LCS</p>
          <div className="growth-path">
            <div className="growth-step">
              <div className="growth-step-icon">🚀</div>
              <div className="growth-step-title">Executive</div>
              <div className="growth-step-desc">Entry Level</div>
            </div>
            <div className="growth-arrow">→</div>
            <div className="growth-step">
              <div className="growth-step-icon">📊</div>
              <div className="growth-step-title">Analyst</div>
              <div className="growth-step-desc">1-3 Years</div>
            </div>
            <div className="growth-arrow">→</div>
            <div className="growth-step">
              <div className="growth-step-icon">👔</div>
              <div className="growth-step-title">Manager</div>
              <div className="growth-step-desc">3-6 Years</div>
            </div>
            <div className="growth-arrow">→</div>
            <div className="growth-step">
              <div className="growth-step-icon">💼</div>
              <div className="growth-step-title">Director</div>
              <div className="growth-step-desc">6-10 Years</div>
            </div>
            <div className="growth-arrow">→</div>
            <div className="growth-step">
              <div className="growth-step-icon">⭐</div>
              <div className="growth-step-title">CXO</div>
              <div className="growth-step-desc">10+ Years</div>
            </div>
          </div>
        </div>
      </section>

      <section className="career-cta">
        <div className="container">
          <div className="cta-content">
            <div className="cta-icon">🎯</div>
            <h2>Ready to Start Your Journey?</h2>
            <p className="cta-subtitle">Send your resume to careers@lcsolution.in</p>
            <p className="cta-description">Join our team of talented professionals and grow your career in the fintech industry</p>
            <button className="btn-primary" onClick={() => window.location.href = 'mailto:careers@lcsolution.in'}>
              Apply Now
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
